/* tslint:disable */
/* eslint-disable */
/**
 * medications
 * medications
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PRNActivityListItem } from './PRNActivityListItem';
import {
    PRNActivityListItemFromJSON,
    PRNActivityListItemFromJSONTyped,
    PRNActivityListItemToJSON,
} from './PRNActivityListItem';

/**
 * 
 * @export
 * @interface FindRecentPrnActivity200Response
 */
export interface FindRecentPrnActivity200Response {
    /**
     * 
     * @type {Array<PRNActivityListItem>}
     * @memberof FindRecentPrnActivity200Response
     */
    data?: Array<PRNActivityListItem>;
}

/**
 * Check if a given object implements the FindRecentPrnActivity200Response interface.
 */
export function instanceOfFindRecentPrnActivity200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindRecentPrnActivity200ResponseFromJSON(json: any): FindRecentPrnActivity200Response {
    return FindRecentPrnActivity200ResponseFromJSONTyped(json, false);
}

export function FindRecentPrnActivity200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindRecentPrnActivity200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(PRNActivityListItemFromJSON)),
    };
}

export function FindRecentPrnActivity200ResponseToJSON(value?: FindRecentPrnActivity200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(PRNActivityListItemToJSON)),
    };
}

